export default {"src":"/_next/static/media/drilldownIcon.afcd3d1e.svg","height":11,"width":10,"blurWidth":0,"blurHeight":0};